const MENU_CURATION_TASK_NO_TAG_FILTER = {
  value: 'NO_TAG',
  label: 'No tags',
}

module.exports = MENU_CURATION_TASK_NO_TAG_FILTER
